import React, { Component } from "react"



export class FormTable extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount(){
        
    }

    render() {
        const {id, text} = this.props.values
        return (
            <tr className="odd">
                <td>{id}</td>
                <td>{text}</td>
                <td>
                    <a href="#" className="text-success">
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </a>
                </td>
                <td>
                    <a href="#" className="text-danger">
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                </td>
            </tr>
        )

    }

}
